(() => {
  if (window.cantripCollectionPreviews) return;
  window.cantripCollectionPreviews = true;
  const jobs = [], responses = new Map(); let running = 0;
  const enqueue = fn => { jobs.push(fn); pump(); };
  const pump = () => { while (running < 3 && jobs.length) { running++; Promise.resolve().then(jobs.shift()).finally(() => { running--; pump(); }); } };
  const request = url => {
    if (!responses.has(url)) responses.set(url, fetch(url, {credentials:'same-origin'}).then(r => {if(!r.ok)throw Error('preview request');return r.text();}).catch(e=>{responses.delete(url);throw e;}));
    return responses.get(url);
  };
  const makeUrl = root => {
    const url = new URL(root.dataset.ctUrl, window.location.origin);
    // A pasted public CANTRIP URL is rendered on the current shop, including theme-editor previews.
    if (!/^\/collections\/[^/]+\/?$/.test(url.pathname)) throw Error('collection URL');
    if (root.dataset.ctSort && root.dataset.ctSort !== 'collection') url.searchParams.set('sort_by', root.dataset.ctSort);
    url.searchParams.delete('page'); url.searchParams.delete('section_id'); url.searchParams.delete('view');
    return new URL(url.pathname + url.search, window.location.origin);
  };
  const load = async root => {
    if (root.dataset.ctLoaded || root.dataset.ctLoading) return;
    root.dataset.ctLoading = 'true';
    const grid = root.querySelector('.product-grid'), viewAll = root.querySelector('[data-ct-view-all]');
    try {
      const base = makeUrl(root); if (viewAll) viewAll.href = base.pathname + base.search;
      const count = Math.max(1, Math.min(25, Number(root.dataset.ctCount) || 9));
      const stockOnly = root.dataset.ctStock === 'true';
      const sectionId = root.dataset.ctSection || 'cantrip-collection-preview';
      let url = new URL(base); url.searchParams.set('section_id', sectionId);
      if (root.dataset.ctSection) url.searchParams.set('view', 'cantrip-preview');
      // Filtering and sorting occur across the collection on Shopify before each page is returned.
      // Availability is also checked below, including stores that do not expose the native filter.
      if (stockOnly) url.searchParams.set('filter.v.availability','1');
      const items = [], seen = new Set(), visited = new Set();
      while (url && items.length <= count) {
        if (visited.has(url.href)) throw Error('preview pagination'); visited.add(url.href);
        const html = new DOMParser().parseFromString(await request(url.href), 'text/html');
        const result = html.getElementById('cantrip-collection-response'); if(!result)throw Error('preview response');
        for(const item of result.querySelectorAll('[data-ct-product]')){
          if(seen.has(item.dataset.ctProduct) || (stockOnly && item.dataset.ctAvailable !== 'true'))continue;
          seen.add(item.dataset.ctProduct); items.push(item); if(items.length>count)break;
        }
        const next = result.dataset.nextPage;
        if (next) {
          const nextPage = new URL(next, url);
          // Keep the original repeated OR filters and sorting on every page.
          // Shopify's next link only supplies the pagination cursor.
          url = new URL(base);
          for (const [key, value] of nextPage.searchParams) {
            if (key === 'page' || key.startsWith('page_')) url.searchParams.set(key, value);
          }
          url.searchParams.set('section_id', sectionId);
          if (root.dataset.ctSection) url.searchParams.set('view', 'cantrip-preview');
          if (stockOnly) url.searchParams.set('filter.v.availability', '1');
        } else url = null;
      }
      const hasMore = items.length > count;
      if (viewAll) viewAll.closest('.collection__view-all')?.toggleAttribute('hidden', !hasMore);
      items.splice(count);
      const fragment = document.createDocumentFragment();
      items.forEach((item,index)=>{
        // Avoid duplicated card/form IDs when a product appears in several TOP sections.
        const idMap = new Map(); item.querySelectorAll('[id]').forEach(el=>{const old=el.getAttribute('id'), next=old+'-'+root.id+'-'+index;el.setAttribute('id',next);idMap.set(old,next);});
        item.querySelectorAll('[for],[form],[aria-labelledby],[aria-describedby],[aria-controls]').forEach(el=>{for(const attr of ['for','form','aria-labelledby','aria-describedby','aria-controls']){const value=el.getAttribute(attr);if(value)el.setAttribute(attr,value.split(' ').map(id=>idMap.get(id)||id).join(' '));}});
        item.querySelectorAll('[data-modal],[href^="#"]').forEach(el=>{for(const attr of ['data-modal','href']){const value=el.getAttribute(attr);if(value?.startsWith('#') && idMap.has(value.slice(1)))el.setAttribute(attr,'#'+idMap.get(value.slice(1)));}});
        item.querySelectorAll('script').forEach(el=>el.remove());
        item.classList.add('scroll-trigger--cancel'); if(grid.classList.contains('slider'))item.classList.add('slider__slide'); fragment.appendChild(item);
      });
      grid.replaceChildren(fragment);
      if(!items.length){const empty=document.createElement('li');empty.className='ct-preview-status';empty.textContent='条件に合う商品はありません。';grid.appendChild(empty);}
      root.querySelector('slider-component')?.resetPages?.();
      root.dataset.ctLoaded='true'; root.dispatchEvent(new CustomEvent('cantrip:products-loaded',{bubbles:true}));
    } catch(_){
      grid.replaceChildren();const message=document.createElement('li');message.className='ct-preview-status';message.textContent='商品を読み込めませんでした。';
      const retry=document.createElement('button');retry.type='button';retry.textContent='再読み込み';retry.addEventListener('click',()=>enqueue(()=>load(root)));message.appendChild(retry);grid.appendChild(message);
    } finally {delete root.dataset.ctLoading;}
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);enqueue(()=>load(entry.target));}}),{rootMargin:'1400px'}) : null;
  const init = () => document.querySelectorAll('[data-ct-collection-preview]').forEach(root=>{
    if(root.dataset.ctObserved)return;
    root.dataset.ctObserved='true';
    const link=root.querySelector('[data-ct-view-all]');
    if(link){try{const url=makeUrl(root);link.href=url.pathname+url.search;}catch(_){}}
    if(root.dataset.ctRemote !== 'true')return;
    if(root.getBoundingClientRect().top < innerHeight + 800)enqueue(()=>load(root));
    else if(observer)observer.observe(root);else enqueue(()=>load(root));
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
